// Compatibility shim for using Ant Design v5 with React 19. Must be first.
import '@ant-design/v5-patch-for-react-19'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/app/App'
import '@/styles/main.scss'
// Tailwind layers are imported after the SCSS base so utility classes are
// available app-wide. SCSS is being phased out in favour of Tailwind + AntD.
import '@/styles/tailwind.css'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element #root not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
